import React from 'react';
import { Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFolder } from '@fortawesome/free-solid-svg-icons';
import Volume from "@/src/_types/volume";
import VolumeItemText from "@/src/components/journal-site/archive/volumes/mui-custom/volume-item-text/volume-item-text";
import VolumeItemBox from "@/src/components/journal-site/archive/volumes/mui-custom/volume-item-box/volume-item-box";

interface VolumeProps {
    volume: Volume;
    isSelected: boolean;
    onClick: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
    id: string;
    ariaControls: string;
}

const VolumeItem: React.FC<VolumeProps> = ({ volume, isSelected, onClick, id, ariaControls }) => {
    return (
        <VolumeItemBox
            onClick={onClick}
            id={id}
            aria-controls={ariaControls}
            aria-selected={isSelected}
            role="tab"
        >
            <VolumeItemText>
                <FontAwesomeIcon icon={faFolder} />
                <Typography sx={{marginLeft: '.5rem'}} component={'label'}>
                    {`Vol. ${volume.volume_name}`}
                </Typography>
            </VolumeItemText>
        </VolumeItemBox>
    );
};

export default VolumeItem;
